(function () {
  if (window.__DT_COLLECTION_QTY_PRICE__) return;
  window.__DT_COLLECTION_QTY_PRICE__ = true;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, Shopify.money_format || window.money_format || "{{amount}}");
    }
    const val = cents / 100;
    return "Rs." + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updateCard(card) {
    const qtyInput = card.querySelector('quantity-selector-component input[name="quantity"]');
    if (!qtyInput) return;

    const qty = Math.max(1, parseInt(qtyInput.value || "1", 10));

    const priceEl = card.querySelector(".price[data-price-unit]");
    if (!priceEl) return;

    const compareEl = card.querySelector(".compare-at-price[data-compare-unit]");

    const unitPrice = parseInt(priceEl.getAttribute("data-price-unit") || "0", 10);
    const unitCompare = compareEl ? parseInt(compareEl.getAttribute("data-compare-unit") || "0", 10) : 0;

    priceEl.textContent = formatMoney(unitPrice * qty);

    if (compareEl && unitCompare > unitPrice && unitCompare > 0) {
      compareEl.textContent = formatMoney(unitCompare * qty);
      compareEl.style.display = "";
    } else if (compareEl) {
      compareEl.style.display = "none";
    }
  }

  function handle(e) {
    const card = e.target.closest("product-card, .product-card");
    if (!card) return;

    // Horizon sometimes updates qty asynchronously
    requestAnimationFrame(() => updateCard(card));
    setTimeout(() => updateCard(card), 0);
    setTimeout(() => updateCard(card), 50);
  }

  document.addEventListener("click", handle, true);
  document.addEventListener("input", handle, true);
  document.addEventListener("change", handle, true);

  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-card, .product-card").forEach(updateCard);
  });
})();
